import { render, staticRenderFns } from "./AssignTeamDialog.vue?vue&type=template&id=ae372910&scoped=true"
import script from "./AssignTeamDialog.vue?vue&type=script&lang=js"
export * from "./AssignTeamDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignTeamDialog.vue?vue&type=style&index=0&id=ae372910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae372910",
  null
  
)

export default component.exports